import { extendTailwindMerge } from 'tailwind-merge';

export const cn = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl'],
      radius: ['sm', 'md', 'lg', 'xl', '2xl', 'circle', 'pill'],
    },
  },
});
